import React from "react";

const FileUploadSection = ({
  isEditing,
  label,
  files = [],
  onChange,
  accept = ".pdf,.ppt,.pptx,.mp4,.mov,.avi",
}) => {
  const handleAdd = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const next = [...(files || []), { id: Date.now(), file }];
    onChange(next);
  };

  const handleRemove = (id) => {
    const next = (files || []).filter((f) => f.id !== id);
    onChange(next);
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">{label}</h2>
        {isEditing && (
          <button
            onClick={() => document.getElementById(`${label}-upload-input`).click()}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add
          </button>
        )}
      </div>

      <input
        id={`${label}-upload-input`}
        type="file"
        onChange={handleAdd}
        className="hidden"
        accept={accept}
        disabled={!isEditing}
      />

      <div className="space-y-2">
        {(files || []).length === 0 && (
          <div className="p-4 text-sm text-gray-500 border border-dashed border-gray-300 rounded-md">No files uploaded yet.</div>
        )}
        {(files || []).map((f) => (
          <div key={f.id} className="flex items-center justify-between border border-[#D6DBEA] rounded-lg bg-[#F8F9FB] px-3 py-2">
            <span className="text-[#1A212F] text-[14px] truncate">{f.file?.name || f.name}</span>
            {isEditing && (
              <button onClick={() => handleRemove(f.id)} className="w-6 h-6 rounded-full bg-[#FF4D4F1A] border border-[#FF4D4F] flex items-center justify-center">
                <span className="text-[#FF4D4F] text-xs font-bold">×</span>
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileUploadSection;

